export default "__VITE_ASSET__ae037e21__"